import { ThemeOptions, createTheme } from '@mui/material/styles';
import { blue, mergeThemeOptions, themeOptions } from '@workboard/wobo-material';
import { createGlobalStyle } from 'styled-components';

/** Exported so anything that must sit above a dialog can stack against the same value. */
export const DIALOG_MIN_Z_INDEX = 1e6;

const themeExtensions: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 480,
      sm: 720,
      md: 1024,
      lg: 1200,
      xl: 1400,
    },
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        root: {
          zIndex: DIALOG_MIN_Z_INDEX,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          height: '38px',
          boxSizing: 'border-box',
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: false,
        disableInteractive: false,
      },
      styleOverrides: {
        popper: {
          '&&': {
            // increase specificity
            zIndex: DIALOG_MIN_Z_INDEX,
          },
        },
        tooltip: {
          borderRadius: 8,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: '100%',
          '&& > fieldset': {
            marginBottom: 0,
            padding: 0
          },
          '&& > input': {
            margin: 0,
            height: 'auto',
            fontSize: '14px',
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          zIndex: DIALOG_MIN_Z_INDEX,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: { zIndex: DIALOG_MIN_Z_INDEX },
      },
    },
    MuiPopper: {
      defaultProps: {
        sx: {
          '&&.MuiPickersPopper-root': {
            zIndex: `${DIALOG_MIN_Z_INDEX}`,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        text: {
          '&:hover, &:focus': {
            backgroundColor: blue[10],
          }
        }
      }
    }
  },
};
export const theme = createTheme(mergeThemeOptions(themeOptions, themeExtensions));

export const GlobalStyle = createGlobalStyle`
  * {
    font-family: Lato, sans-serif;
  }
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
  a {
    text-decoration: none;
  }
  div[role="tooltip"] {
    z-index: 10;
  }
`;
